import * as eventNames from './eventNames';
export function getEventName(eventNamespace, eventName) {
    eventNamespace = eventNamespace.replace(/\.$/, '');
    eventName = eventName.replace(/^\./, '');
    return [eventNamespace, eventName].join('.');
}
export function getAllKnownEventNames(eventNamespace) {
    return Object.values(eventNames).map(name => getEventName(eventNamespace, name));
}
export function deepClone(obj) {
    if (obj === null || typeof obj !== 'object') {
        return obj;
    }
    if (Array.isArray(obj)) {
        const clonedArray = [];
        for (let i = 0; i < obj.length; i++) {
            clonedArray[i] = deepClone(obj[i]);
        }
        return clonedArray;
    }
    if (obj instanceof Date) {
        return new Date(obj.getTime());
    }
    const clonedObj = {};
    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            clonedObj[key] = deepClone(obj[key]);
        }
    }
    return clonedObj;
}
//# sourceMappingURL=utils.js.map